<template>
  <div style="margin-top: 15px" class="pa-3">
    <div class="form-component" v-if="$parent.pageFixedSettings.footer.block[0].config[3]">
      <label for="">Logo</label>
      <UploadOneImage
        :image="{ src: $parent.pageFixedSettings.footer.block[0].config[3].value }"
        @callback="getImageDeskTop"
      />
      <!-- <images-uploader
        :images="[{ src: $parent.pageFixedSettings.footer.block[0].config[3].value }]"
        @callback="$parent.getImageUpLoadLogoFooter"
      /> -->
    </div>
    <div class="form-component mt-2" v-if="getGemLogoConfig()">
      <label for="">Gem logo</label>
      <UploadOneImage :image="{ src: getGemLogoConfig().value }" @callback="getImageGemLogo" />
    </div>
    <div class="form-component mt-2" v-if="getGemBgColorConfig()">
      <label for="">Gem bg color</label>
      <v-menu v-model="gemBgColorMenu" offset-y :close-on-content-click="false">
        <template #activator="{ on, attrs }">
          <v-text-field readonly hide-details="" v-bind="attrs" v-on="on" :value="getGemBgColorConfig().value">
            <template #prepend-inner>
              <span
                :style="{
                  display: 'inline-block',
                  width: '20px',
                  height: '20px',
                  borderRadius: '4px',
                  background: getGemBgColorConfig().value,
                  border: '1px solid #ccc',
                  marginTop: '2px',
                }"
              ></span>
            </template>
          </v-text-field>
        </template>
        <v-color-picker :value="getGemBgColorConfig().value" mode="hexa" show-swatches flat @input="updateGemBgColor" />
      </v-menu>
    </div>
    <div class="form-component mt-2" v-if="getGemColorConfig()">
      <label for="">Gem color</label>
      <v-menu v-model="gemColorMenu" offset-y :close-on-content-click="false">
        <template #activator="{ on, attrs }">
          <v-text-field readonly hide-details="" v-bind="attrs" v-on="on" :value="getGemColorConfig().value">
            <template #prepend-inner>
              <span
                :style="{
                  display: 'inline-block',
                  width: '20px',
                  height: '20px',
                  borderRadius: '4px',
                  background: getGemColorConfig().value,
                  border: '1px solid #ccc',
                  marginTop: '2px',
                }"
              ></span>
            </template>
          </v-text-field>
        </template>
        <v-color-picker :value="getGemColorConfig().value" mode="hexa" show-swatches flat @input="updateGemColor" />
      </v-menu>
    </div>
    <v-divider class="my-4"></v-divider>
    <div class="form-component mt-2">
      <label for="">Address</label>
      <v-textarea
        v-model="$parent.pageFixedSettings.footer.block[0].config[0].value"
        @input="$parent.changeConfig('footer', 0)"
        autocomplete="new-password"
        hide-details=""
        id="id"
      ></v-textarea>
    </div>
    <div class="form-component mt-2">
      <label for="">Email</label>
      <v-text-field
        v-model="$parent.pageFixedSettings.footer.block[0].config[1].value"
        @input="$parent.changeConfig('footer', 0)"
        autocomplete="new-password"
        hide-details=""
        id="id"
      ></v-text-field>
    </div>
    <div class="form-component mt-2">
      <label for="">Mobile</label>
      <v-text-field
        v-model="$parent.pageFixedSettings.footer.block[0].config[5].value"
        @input="$parent.changeConfig('footer', 0)"
        autocomplete="new-password"
        hide-details=""
        id="id"
      ></v-text-field>
    </div>
    <div class="form-component mt-2">
      <label for="">CoppyRight</label>
      <v-textarea
        v-model="$parent.pageFixedSettings.footer.block[0].config[2].value"
        @input="$parent.changeConfig('footer', 0)"
        autocomplete="new-password"
        hide-details=""
        id="id"
      ></v-textarea>
    </div>
    <div v-if="$parent.pageFixedSettings.footer.block[0].config[4]" class="form-component mt-2">
      <label for="">Sub CoppyRight</label>
      <v-text-field
        v-model="$parent.pageFixedSettings.footer.block[0].config[4].value"
        @input="$parent.changeConfig('footer', 0)"
        autocomplete="new-password"
        hide-details=""
        id="id"
      ></v-text-field>
    </div>
    <div class="form-component mt-7">
      <div class="d-flex justify-space-between">
        <label for="">Main Menu</label>
        <span class="pointer link-add" @click="$router.push({ name: 'website.menus' })">Edit Menu</span>
      </div>
      <v-select
        hide-details=""
        v-model="$parent.pageFixedSettings.footer.block[1].config[0].value"
        :items="$parent.mainMenu"
        @input="$parent.changeConfig('menuFooter', 0)"
        item-text="title"
        item-value="id"
      ></v-select>
    </div>
    <v-row v-if="$parent.pageFixedSettings.footer.block[2]">
      <v-col cols="12">
        <h4>CONTENT</h4>
      </v-col>
      <v-expansion-panels accordion class="list-section" style="max-height:1100px !important">
        <draggable v-model="$parent.pageFixedSettings.footer.block[2].config" @change="change" style="width: 100%;">
          <transition-group>
            <v-expansion-panel v-for="(item, i) in $parent.pageFixedSettings.footer.block[2].config" :key="`item${i}`">
              <v-expansion-panel-header expand-icon="mdi-menu-down" class="heading">
                <i class="fas fa-bars mr-2" style="flex:none !important"></i>

                {{ 'Payment Icon' }}</v-expansion-panel-header
              >
              <v-expansion-panel-content>
                <!-- {{ item.content }} -->
                <UploadOneImage :itemSetData="item" :image="{ src: item.value }" @callback="getImage" />
                <div class="mt-2">
                  <span class="pointer font-weight-bold red--text" @click="removeContent(i)">
                    Remove icon
                  </span>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </transition-group>
        </draggable>
      </v-expansion-panels>
      <v-col v-if="$parent.pageFixedSettings.footer.block[2]" cols="12">
        <span class="pointer font-weight-bold primary--text" @click="addContent">+ Add Image Payment</span>
      </v-col>
    </v-row>
    <v-row v-if="socialBlock" class="mt-2">
      <v-col cols="12">
        <h4>SOCIAL LINKS</h4>
      </v-col>
      <v-expansion-panels accordion class="list-section" style="max-height:1100px !important">
        <draggable v-model="socialBlock.config" @change="change" style="width: 100%;">
          <transition-group>
            <v-expansion-panel v-for="(item, i) in socialBlock.config" :key="`social${i}`">
              <v-expansion-panel-header expand-icon="mdi-menu-down" class="heading">
                <i class="fas fa-bars mr-2" style="flex:none !important"></i>
                {{ `Social Link ${i + 1}` }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div class="mt-2">
                  <label>Icon</label>
                  <UploadOneImage
                    :itemSetData="item"
                    :image="{ src: item.icon }"
                    @callback="img => onSocialIconUpload(img, item)"
                  />
                </div>
                <div class="mt-2">
                  <label>URL</label>
                  <v-text-field
                    v-model="item.url"
                    hide-details=""
                    placeholder="https://"
                    @input="$parent.changeConfig('footer', 0)"
                  ></v-text-field>
                </div>
                <div class="mt-2">
                  <span class="pointer font-weight-bold red--text" @click="removeSocial(i)">Remove</span>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </transition-group>
        </draggable>
      </v-expansion-panels>
      <v-col cols="12">
        <span class="pointer font-weight-bold primary--text" @click="addSocial">+ Add Social Link</span>
      </v-col>
    </v-row>
    <v-row v-if="supportersBlock" class="mt-2">
      <v-col cols="12">
        <h4>SUPPORTERS</h4>
      </v-col>
      <v-expansion-panels accordion class="list-section" style="max-height:1100px !important">
        <draggable v-model="supportersBlock.config" @change="change" style="width: 100%;">
          <transition-group>
            <v-expansion-panel v-for="(item, i) in supportersBlock.config" :key="`supporter${i}`">
              <v-expansion-panel-header expand-icon="mdi-menu-down" class="heading">
                <i class="fas fa-bars mr-2" style="flex:none !important"></i>
                {{ `Supporter ${i + 1}` }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div class="mt-2">
                  <label>Image</label>
                  <UploadOneImage
                    :itemSetData="item"
                    :image="{ src: item.image }"
                    @callback="img => onSupporterImageUpload(img, item)"
                  />
                </div>
                <div class="mt-2">
                  <label>URL</label>
                  <v-text-field
                    v-model="item.url"
                    hide-details=""
                    placeholder="https://"
                    @input="$parent.changeConfig('footer', 0)"
                  ></v-text-field>
                </div>
                <div class="mt-2">
                  <span class="pointer font-weight-bold red--text" @click="removeSupporter(i)">Remove</span>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </transition-group>
        </draggable>
      </v-expansion-panels>
      <v-col cols="12">
        <span class="pointer font-weight-bold primary--text" @click="addSupporter">+ Add Supporter</span>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import draggable from 'vuedraggable';

export default {
  components: {
    draggable,
  },
  data() {
    return {
      gemBgColorMenu: false,
      gemColorMenu: false,
    };
  },
  computed: {
    socialBlock() {
      return this.$parent.pageFixedSettings.footer.block.find(b => b.component === 'social') || null;
    },
    supportersBlock() {
      return this.$parent.pageFixedSettings.footer.block.find(b => b.component === 'supporters') || null;
    },
  },
  methods: {
    ensureSocialBlock() {
      const blocks = this.$parent.pageFixedSettings.footer.block;
      const hasSocialBlock = blocks.some(b => b.component === 'social');
      if (!hasSocialBlock) {
        blocks.push({
          order: '4',
          label: 'Social Links',
          component: 'social',
          config: [],
        });
      }
    },
    ensureGemConfigs() {
      const config = this.$parent.pageFixedSettings.footer.block[0].config;
      const gemConfigDefaults = [
        {
          label: 'Gem logo',
          driver: 'image-select',
          default: null,
          value: null,
        },
        {
          label: 'Gem bg color',
          driver: 'color-picker',
          default: '#FFFFFF',
          value: '#FFFFFF',
        },
        {
          label: 'Gem color',
          driver: 'color-picker',
          default: '#000000',
          value: '#000000',
        },
      ];
      gemConfigDefaults.forEach(item => {
        const hasConfig = config.some(configItem => configItem.label === item.label);
        if (!hasConfig) {
          config.push({ ...item });
        }
      });
    },
    getConfigByLabel(label) {
      const config = this.$parent.pageFixedSettings.footer.block[0].config;
      return config.find(item => item.label === label) || null;
    },
    getGemLogoConfig() {
      return this.getConfigByLabel('Gem logo');
    },
    getGemBgColorConfig() {
      return this.getConfigByLabel('Gem bg color');
    },
    getGemColorConfig() {
      return this.getConfigByLabel('Gem color');
    },
    getImageDeskTop(image) {
      this.$parent.pageFixedSettings.footer.block[0].config[3].value = image.src;
      this.$parent.changeConfig('menu', 0);
    },
    getImageGemLogo(image) {
      const gemLogoConfig = this.getGemLogoConfig();
      if (!gemLogoConfig) {
        return;
      }
      gemLogoConfig.value = image.src;
      this.$parent.changeConfig('menu', 0);
    },
    updateGemBgColor(color) {
      const gemBgColorConfig = this.getGemBgColorConfig();
      if (!gemBgColorConfig) {
        return;
      }
      gemBgColorConfig.value = color;
      this.$parent.changeConfig('menu', 0);
    },
    updateGemColor(color) {
      const gemColorConfig = this.getGemColorConfig();
      if (!gemColorConfig) {
        return;
      }
      gemColorConfig.value = color;
      this.$parent.changeConfig('menu', 0);
    },
    getImage(images, item) {
      item.value = images.src;
      this.$parent.changeConfig();
      //   this.attributes.image = images;
    },
    removeContent(i) {
      this.$parent.pageFixedSettings.footer.block[2].config.splice(i, 1);
      this.$parent.changeConfig();
    },
    change() {
      this.$parent.changeConfig();
    },
    addContent() {
      this.$parent.pageFixedSettings.footer.block[2].config.push({
        label: 'Icon 1',
        driver: 'select',
        default: null,
        value: null,
      });
    },
    addSocial() {
      if (!this.socialBlock) return;
      this.socialBlock.config.push({
        icon: null,
        url: '',
      });
      this.$parent.changeConfig('footer', 0);
    },
    removeSocial(i) {
      if (!this.socialBlock) return;
      this.socialBlock.config.splice(i, 1);
      this.$parent.changeConfig('footer', 0);
    },
    onSocialIconUpload(img, item) {
      item.icon = img.src;
      this.$parent.changeConfig('footer', 0);
    },
    ensureSupportersBlock() {
      const blocks = this.$parent.pageFixedSettings.footer.block;
      const hasSupportersBlock = blocks.some(b => b.component === 'supporters');
      if (!hasSupportersBlock) {
        blocks.push({
          order: '4',
          label: 'Supporters',
          component: 'supporters',
          config: [],
        });
      }
    },
    addSupporter() {
      if (!this.supportersBlock) return;
      this.supportersBlock.config.push({
        image: null,
        url: '',
      });
      this.$parent.changeConfig('footer', 0);
    },
    removeSupporter(i) {
      if (!this.supportersBlock) return;
      this.supportersBlock.config.splice(i, 1);
      this.$parent.changeConfig('footer', 0);
    },
    onSupporterImageUpload(img, item) {
      item.image = img.src;
      this.$parent.changeConfig('footer', 0);
    },
  },
  mounted() {
    this.ensureGemConfigs();
    this.ensureSocialBlock();
    this.ensureSupportersBlock();
  },
};
</script>

<style lang="scss" scoped></style>
